import type { CognitoClientOptions } from "./CognitoClientOptions"

export const getAuthorizeUrl = (config: CognitoClientOptions) => {
	const state = `${window.location.origin}${window.location.pathname}${encodeURIComponent(window.location.search)}`
	return `https://${config.host}/oauth2/authorize?response_type=code&client_id=${config.clientId}&redirect_uri=${config.redirectUri}&state=${state}`
}
